
<mat-dialog-content>
  <div class="confrim-dialog-wrapper">
    <h2 class="cmn-popup-title">{{ data?.title || 'Confirm Delete?' }}</h2>
    <button class="cmn-close" mat-dialog-close></button>
    <p>{{ data?.message  || 'Are you sure you want to delete?' }}</p>
    <div class="submit-btn-wrapper">
      <button class="cmn-cancel-btn" (click)="onCancel()">Cancel</button>
      <button class="cmn-next-btn" (click)="onDelete()">{{ data?.confirmText || 'Delete' }}</button>
    </div>
  </div>
</mat-dialog-content>
